import * as constants from '../constants';

const initialState = {
    results: []
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getDiseasesCausativeAgent.success: {
            return action.payload;
        }

        default:
            return state;
    }
}
